export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14728.09c95b91.jpg";